import { getCapacitorPlatform, type Platform } from "shared/features/platform";
import { getDesktopBridge } from "./Desktop";

// Platform 타입의 정본은 shared/features/platform(서버 세션과 공유). 기존 소비처가
// 계속 `./platform` 에서 참조할 수 있도록 재노출한다.
export type { Platform };

// 실행 플랫폼 판별. Electron 셸(apps/desktop)은 preload가 window.desktop 을 노출해
// 감지하고, Capacitor 셸은 네이티브 브리지가 주입하는 전역 Capacitor 객체로 감지한다
// (getCapacitorPlatform 이 그 전역 읽기를 담당 — @app/ui 의 Haptics 와 공유).

export function detectPlatform(): Platform {
  if (getDesktopBridge()) return "desktop";
  const capPlatform = getCapacitorPlatform();
  // Capacitor 네이티브 셸에서 실행 중인지
  const isNativeShell = capPlatform === "android" || capPlatform === "ios";
  if (isNativeShell) return capPlatform;
  return "web";
}
